import React from "react";
import { CloseIcon } from "../icons/CloseIcon";

interface CloseButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  id?: string;
}

export const CloseButton: React.FC<CloseButtonProps> = ({
  onClick,
  ariaLabel = "Close",
  id = "sheet-close-button",
}) => (
  <button id={id} onClick={onClick} className="btn-icon" aria-label={ariaLabel}>
    <CloseIcon />
  </button>
);
